<template>
    <div>
        <breadcrumbs
                :title="'Notifikacije'"
                :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox ">
            <div class="ibox-title">
                <h5>Notifikacije</h5><br>
                <button
                        type="button"
                        class="btn btn-lg btn-primary"
                        @click.prevent="create"
                >
                    Nova notifikacija
                </button>
            </div>
            <div class="ibox-content">
                <datatables
                        v-if="show_datatable"
                        :url="datatables_url"
                        :settings="datatables.settings"
                        :title="datatables.title"
                >
                </datatables>
            </div>
        </div>
    </div>

</template>

<script>
import Datatables from "@/components/datatable/Datatables";
import Breadcrumbs from "@/components/breadcrumbs/Breadcrumbs";

export default {
name: "Notifikacije",
    components: { Breadcrumbs, Datatables},
    data(){
        return {
            show_datatable: false,
            datatables_url: process.env.VUE_APP_API_URL +  'notifikacija',
            datatables:{},
            breadcrumbs:[],
        }
    },
    methods:{
        create(){
            this.$router.push( { path: '/notifikacije/create' } )
        },
        setDatatable(){
            let vm = this;
            vm.datatables = {
                settings: {
                    table_header:[
                        {
                            'id': 'id',
                            'visible': false,
                        },
                        {
                            'id': 'naslov',
                            'title': 'Naslov',
                            'column_visibility_group': {
                                id: 'notifikacija',
                            }
                        },
                        // {
                        //     'id': 'podnaslov',
                        //     'title': 'Podnaslov',
                        //     'column_visibility_group': {
                        //         id: 'notifikacija',
                        //     }
                        // },
                        {
                            'id': 'url',
                            'title': 'URL',
                            'column_visibility_group': {
                                id: 'notifikacija',
                            }
                        },
                        {
                            'id': 'poruka',
                            'title': 'Poruka',
                            'column_visibility_group': {
                                id: 'notifikacija',
                            }
                        },
                        {
                            'id': 'poslano',
                            'title': 'Poslano',
                            'type' : function( row ){
                                return row['poslano'] ? 'DA' : 'NE'
                            },
                            'column_visibility_group': {
                                id: 'notifikacija',
                            }
                        }
                    ],
                    column_visibility_groups:{
                        'notifikacija' : 'Notifikacije'
                    },
                    order: 'desc',
                    order_by: 'id',
                },
                title: 'Notifikacije',
            }
            vm.show_datatable = true;
        },

        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/notifikacije',
                    name: 'Notifikacije'
                }
            ];
        }
    },
    mounted() {
        this.setDatatable()
        this.setBreadcrumbs()
    }
}
</script>

<style scoped>

</style>
